import { render, staticRenderFns } from "./ProjectInspections.vue?vue&type=template&id=5e2f5f03&"
import script from "./ProjectInspections.vue?vue&type=script&lang=js&"
export * from "./ProjectInspections.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInspections.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports